<script>
    import { onMount } from "svelte";
    import { push, location } from "svelte-spa-router";
    import { groups_en, groups_fi, groupIcons, pageTitles_fi, pageTitles_en, colors, info } from "../scripts/questions";
    import { questions, readOnly, craft, lang } from "../scripts/stores";
    import { changeBgColor } from "../scripts/utils";
    import Question from "../components/Question.svelte";
    import InfoPage from "../components/InfoPage.svelte";
    import Stepper from "../components/Stepper.svelte";
    import Arrow from "../components/Arrow.svelte";
    import Toast from "../components/Toast.svelte";
    import Tools from "../components/Tools.svelte";

    export let params = {};

    let pageTitles = [], groups = [];
    let lastPage = pageTitles_fi.length;

    $: if($lang) {
        pageTitles = $lang === "fi" ? pageTitles_fi : pageTitles_en;
        groups = $lang === "fi" ? groups_fi : groups_en;
    }

    
    let group = params.group ? Number(params.group) : 1;
    let page =  params.page ? Number(params.page) : 1;
    
    let pageTitle;
    let showInfo = false;
    let openToast = $readOnly;
    let showCraft = false;

    $: if(page) {
        let index = info.findIndex(x => x.group === group);
        
        if(!info[index].isShowed) {
            info[index].isShowed = true;
            showInfo = true;
        }
    }

    $: pageTitle = page - 1;

    $: if($craft) showCraft = true;
       else showCraft = false;

    $: if(page === lastPage) { 
        push("/results-info");
    }

    function setGroup(currentGroup) {
        group = currentGroup;
        return "";
    }

    function nextPage() { 
        page += 1;
        $questions = $questions;
        push(`/form/${group}/${page}`);
        window.scrollTo(0, 0);
    }

    function prevPage() { 
        page -= 1;
        $questions = $questions;
        push(`/form/${group}/${page}`);
    }

    $: if(group >= 1) {
		if(document.body) {
            if($location === "/form/4/16") changeBgColor("#fff");
            else changeBgColor(colors[group - 1]);
		}
	}

	onMount(() => {
        if($location === "/form/4/16") changeBgColor("#fff");
        else changeBgColor(colors[group - 1]);
	});

</script>

<style>
    .questions-container {
        max-width: 640px;
        margin-left: auto;
        margin-right: auto;
    }
</style>

<div class="container">
    <Stepper bind:step={ group } stepTitles={ groups } />

    {#if showInfo}
        <InfoPage bind:show={ showInfo } group={  group }/>
    {:else}

        <div class="questions-container">

            <h2>
                <i class="material-icons large-icon">{  groupIcons[group - 1] }</i>
                { groups[group - 1] }
            </h2>

            <h3> { pageTitles[pageTitle] } </h3>

            {#each $questions as question, i}
                { question.page === page ? setGroup(question.group) : "" }
                <Question { question } bind:page index={ i + 1 }/>
            {/each}


            <div class="buttons">
                <button 
                    class="btn btn-outline btn-primary" 
                    disabled={ page > 1 ? false : true  }
                    on:click={ prevPage }
                >
                    <Arrow direction="left" />
                    { $lang === "fi" ? "Edellinen" : "Previous" }
                </button>

                <button class="btn btn-primary" on:click={ nextPage }>
                    {#if page === lastPage - 1}
                        { $lang === "fi" ? "Näytä tulokset" : "Show results" }
                    {:else}
                        { $lang === "fi" ? "Seuraava" : "Next" }
                        <Arrow />
                    {/if}
                </button>
            </div>
        </div>
    {/if}
</div>

<Tools />

<Toast bind:open={ openToast } />
<!-- <CraftToast show={ showCraft } /> -->